export enum EVENTS {
  DOCUMENTS_SIGNED = 'Trade Docs Signed - Web',
  ONBOARDING_STEP_COMPLETED = 'Onboarding Step Completed - Web',
  CTA_CLICKED = 'CTA Clicked - Web',
  ACCOUNT_CREATED = 'User Account Login Created - Web',
  PROPERTY_VIEWED = 'Property Viewed - Web',
  PORTFOLIO_PAGE_VIEWED = 'Portfolio Page Viewed - Web',
  BROKERAGE_ACCOUNT_CREATED = 'Brokerage Account Created - Web',
  OFFERING_FEATURED_FILTER_CLICKED = 'Offering Featured Filter Clicked - Web',
  OFFERING_FILTER_CLICKED = 'Offering Filter Clicked - Web',
  EMAIL_SUBSCRIPTION = 'email_subscription',
  BANK_LINK = 'Bank Account Updated - Web',
  PLAID_BANK_LINKED = 'plaid_bank_linked',
  EXPERIMENT_VIEWED = 'experiment_viewed',
  OFFERING_VIDEO_WATCHED = 'offering_video_watched',
  LEAD_FORM_COMPLETED = 'Lead Form Completed - Web',
  SIGNUP_FORM_DISPLAYED = 'Signup Form Displayed - Web',

  // Native Enums

  /**
   * When using the native app, this event is fired when the user
   * clicks on a deep link that redirected them to the application.
   */
  DEEP_LINK = 'Deep Link - Mobile',

  ONBOARDING_STEP_COMPLETED_MOBILE = 'Onboarding Step Completed - Mobile',
  /**
   * When a user ends up on a not found, we should be notified
   */
  NOT_FOUND = 'Not Found - Mobile',
}
